import DeviceService from 'Services/device';
import Search from 'Mixins/search';
import Vue from 'vue';

export default {
	name: 'new-group-modal',
	mixins: [Search],
	created() {
		if (!this.$route.params.credential) {
			this.$router.replace('/devices');
			return;
		}
		this.devices = this.$route.params.credential;
		this.currentFilter = this.$route.params.filter;
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
		// workaround for rendering issue in chrome #575
		Vue.nextTick(() => {
			this.forceRerender();
		});
	},
	data() {
		return {
			isSaving: false,
			groupName: '',
			devices: [],
			errorSnack: {
				visible: false,
				message: ''
			},
			rendererKey: 0
		};
	},
	methods: {
		createNewGroup() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isSaving = true;
					DeviceService.createNewGroup(this.groupName, this.devices)
						.then(response => {
							this.$store.dispatch('updateDevices', {
								search: this.isBackendSearchUsed ? this.currentFilter : '',
								force: true
							});
							this.$parent.selectedDevices = [];
							this.back();
						})
						.catch(error => {
							if (error.response.status >= 400 && error.response.status < 500) {
								this.errorSnack.message = 'Device group already exist';
							} else {
								this.errorSnack.message = 'Something went wrong (Error 500)<br>Please try again';
							}
							this.errorSnack.visible = true;
						})
						.finally(() => {
							this.isSaving = false;
						});
				}
			});
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/devices');
			}
		},
		forceRerender() {
			this.rendererKey += 1;
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/new-group-modal/script.js